import { useState } from "react";
import isEqual from "lodash-es/isEqual";
import pullAllWith from "lodash-es/pullAllWith";
import { products_shop_collections_products_variants } from "../../__generated__/products";
import getUndef from "../../lib/get-undef";

const useVariants = (
  variants: products_shop_collections_products_variants[],
  index = 0
) => {
  const defaultSelected = getUndef(
    () => variants[variants.length > 1 ? index : 0]
  );
  const [selected, setSelected] = useState(defaultSelected);
  const [options, setOptions] = useState(
    variants && variants.length > 1
      ? markUnavailableOptions(selected, createOptions(variants), variants)
      : []
  );

  function createOptions(
    variants: products_shop_collections_products_variants[]
  ) {
    let options = [];

    if (!variants || !variants.length) {
      return options;
    }

    variants.map((variant) => {
      variant.selectedOptions.map((option) => {
        if (options[option.name] === undefined) {
          options[option.name] = [];
        }

        const hasName = options[option.name].filter(
          (opt) => opt.value === option.value
        );
        if (hasName.length) return;

        options[option.name].push({
          id: variant.id,
          value: option.value,
        });
      });
    });

    options = Object.keys(options).map((key) => ({
      name: key,
      values: options[key].map((opt) => opt.value),
      valuesWithParams: options[key].map((option) => ({
        ...option,
        variant: variants.find(({ id }) => id === option.id),
      })),
    }));

    return options;
  }

  function selectVariant(name, value) {
    const newSelected = selected.selectedOptions.map((variant) => {
      if (variant.name === name) {
        return {
          name,
          value,
        };
      } else {
        return {
          name: variant.name,
          value: variant.value,
        };
      }
    });

    const newVariant = variants.find((variant) => {
      let result = true;

      if (variant.selectedOptions.length) {
        variant.selectedOptions.filter((curr) => {
          const selectedField = newSelected.find(
            (field) => field.name === curr.name
          );
          result = result && curr.value === selectedField.value;
          return curr.value === selectedField.value;
        });
      } else {
        result = variant.name === value;
      }

      return result;
    });

    if (newVariant) {
      setSelected(newVariant);
      setOptions(getUnavailableOptions(newVariant, variants));
    }
  }

  function markUnavailableOptions(selected, options, variants) {
    // Find unavaliable options
    let existing = [];
    let possible = [];

    selected.selectedOptions.map((option) => {
      // Existing pairs
      let exPairs = [];
      variants.filter((variant) => {
        // Check if variant contains selected option
        const containsOption =
          variant.selectedOptions.filter(
            (varOption) => varOption.value === option.value
          ).length > 0;

        if (containsOption) {
          // Store all existing pairs
          variant.selectedOptions
            .filter((varOption) => varOption.name !== option.name)
            .map((pair) => {
              exPairs.push({
                name: pair.name,
                value: pair.value,
              });
            });
        }
      });
      existing.push({
        name: option.name,
        value: option.value,
        pairs: exPairs,
      });

      let posPairs = [];
      options
        .filter((inOption) => inOption.name !== option.name)
        .map((inOption) => {
          inOption.values.map((value) => {
            posPairs.push({
              name: inOption.name,
              value,
            });
          });
        });

      possible.push({
        name: option.name,
        value: option.value,
        pairs: posPairs,
      });
    });

    let unavailable = existing.map((item) => {
      const pos = possible.filter((posItem) => posItem.name === item.name)[0]
        .pairs;
      const ex = item.pairs;
      const res = pullAllWith(pos, ex, isEqual);
      return res.length > 0 ? res : null;
    });

    unavailable = unavailable
      .filter((item) => item !== null)
      .map((item) => {
        let result = {
          name: item[0].name,
          values: item.map((it) => it.value),
        };
        return result;
      });

    // Mark unavailable options
    const markedOptions = options.map((option) => {
      const unav = unavailable.filter((unOpt) => {
        return unOpt.name === option.name;
      })[0];

      return {
        ...option,
        values: option.values.map((val) => ({
          name: val,
          available: unav
            ? unav.values.filter((unavName) => unavName === val).length === 0
            : true,
        })),
      };
    });

    return markedOptions;
  }

  function getUnavailableOptions(selected, variants) {
    let options = createOptions(variants);

    if (!options.length && variants.length > 1) {
      options = [
        {
          name: "Вариант",
          values: variants.map((variant) => variant.name),
        },
      ];
    }

    return markUnavailableOptions(selected, options, variants);
  }

  return {
    selected,
    options,
    selectVariant,
  };
};

export default useVariants;
